<!-- 各保险公司理赔比例(%) -->
<template>
	<div :id="id" class="o-echarts"></div>
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts';
import moment from 'moment';
let chart = null;
export default {
	name: 'SettlementProportionChart',
	props: {
		id: {
			type: String,
			required: false,
			default: 'chart'
		},
		subtext: {
			type: String,
			required: false,
			default: moment().format('YYYY年MM月DD日')
		}
	},
	data() {
		return {
			// id: 'areaPercentageChart',//地图渲染容器id
			option:{
							title: {
								text: '(外圆理赔面积占比，内圆理赔金额占比)',//主标题
								textStyle: {
									//主标题的属性
									color: 'rgba(0, 0, 0, 0.4)', //颜色
									fontSize: 12, //大小
								},
								subtext: '(2020年6月4日)',
								left: 'right',
								 // textAlign: 'auto',//整体（包括 text 和 subtext）的水平对齐
							},
			
							dataset: [
								//模拟数据
								// {
								// 	source: [
								// 		{ type: '华安保险', labelValue: 50 },
								// 		{ type: '永安保险', labelValue: 30 },
								// 		{ type: '天安保险', labelValue: 60 },
								// 		{ type: '人民保险', labelValue: 70 },
								// 		{ type: '人寿保险', labelValue: 50 },
								// 		{ type: '阳光保险', labelValue: 60 },
								// 		{ type: '太平洋保险', labelValue: 90 },
								// 		{ type: '华泰保险', labelValue: 20 },
								// 		{ type: '大众保险', labelValue: 10 },
								// 		{ type: '东方保险', labelValue: 40 }
								// 	]
								// },
								// {
								// 	source: [
								// 		{ type: '华安保险', labelValue: 50 },
								// 		{ type: '永安保险', labelValue: 30 },
								// 		{ type: '天安保险', labelValue: 60 },
								// 		{ type: '人民保险', labelValue: 70 },
								// 		{ type: '人寿保险', labelValue: 50 },
								// 		{ type: '阳光保险', labelValue: 60 },
								// 		{ type: '太平洋保险', labelValue: 90 },
								// 		{ type: '华泰保险', labelValue: 20 },
								// 		{ type: '大众保险', labelValue: 10 },
								// 		{ type: '东方保险', labelValue: 40 }
								// 	]
								// }
							],
							tooltip: {
								trigger: 'item',
								// formatter: "{a} <br/>{b} : {c} ({d}%)"
								formatter: function(params, ticket, callback) {
									return params.name + '<br>' + '面积：' + params.value.labelValue + '亩' + '<br>' + '占比：' + params.percent + '%';
									// return params.seriesName+' <br>'+params.name+': '+params.value.labelValue+' ('+params.percent+'%)';
								}
							},
							legend: {
								orient: 'vertical',
								right: '4%',
								top: '16%',
								bottom: 10,
								itemGap: 10,
								itemWidth: 10,
								itemHeight: 10,
								textStyle: {
									color: '#333'
								},
								icon: 'rect',
								// data: ["华安保险", "永安保险", "天安保险","人民保险","人寿保险","阳光保险","太平洋保险","华泰保险","大众保险","东方保险"]
							},
							// color: ['#1a8dee', '#13cdcc', '#ff9023', '#02C874', '#0000E3', '#8600FF', '#FFDC35', '#80FFFF', '#B766AD', '#FF60AF'],
							color: ["#1a8dee", "#4ab2e9", "#13cdcc","#ff9023",'#02C874', '#0000E3', '#8600FF', '#FFDC35', '#80FFFF', '#B766AD', '#FF60AF'],
							series: [
								{
									// name: "",
									type: 'pie',
									radius: ['42%', '60%'],
									center: ['30%', '50%'],
									label: {
										show: false,
										// position: "inside",
										fontSize: 14,
										color: '#666',
										formatter(val) {
											//   return val.value+'亩';
										}
									},
			
									emphasis: {
										itemStyle: {
											shadowBlur: 10,
											shadowOffsetX: 0,
											shadowColor: 'rgba(0, 0, 0, 0.5)'
										}
									},
									labelLine: {
										show: false
									},
									encode: {
										itemName: 'type',
										value: 'labelValue'
									},
			
							 		datasetIndex: 0
								},
						
								 {
			            // name: "大豆政策保险完成比列(%)",
			            type: "pie",
			            radius: ["20%", "36%"],
			            center: ["30%", "50%"],
			            label: {
			              show: false,
			              // position: "inside",
			              fontSize: 14,
			              color: "#666",
			              formatter (val) {
			                //   return val.value+'亩';
			              }
			            },
			            emphasis: {
			              itemStyle: {
			                shadowBlur: 10,
			                shadowOffsetX: 0,
			                shadowColor: "rgba(0, 0, 0, 0.5)"
			              }
			            },
			            labelLine: {
			              show: false
			            },
			            datasetIndex: 1,
			            encode: {
			              itemName: "type",
			              value: "labelValue"
			            },
			         
			          },
							]
						}
				
		};
	},
	mounted() {
		//this.initMap()
	},
	watch: {},
	methods: {
		listenResize() {
			//窗口改变大小
			if (chart) {
				chart.resize();
			}
		},
		initMap(optionData) {
			//设置时间
			this.option.title.subtext = optionData.date+'年' || '';
			this.option.dataset = optionData.dataset;
			// this.option.series[0].data = optionData.series
			chart = echarts.init(document.getElementById(this.id));
			chart.setOption(this.option);
		}
	},
	components: {}
};
</script>

<style scoped lang="less">
.o-echarts {
	min-width: 30px;
	min-height: 30px;
	width: 100%;
	height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/homechart/SettlementProportionChart.vue